import DispatchFile from '@/types/dispatch/dispatch_file'
import { BaseService } from './../../base'
export class DispatchFileService extends BaseService<DispatchFile>() {
    static get entity (): string {
        return 'dispatch_file'
    }
    static get responseName (): string {
        return 'dispatch_file'
    }
}